// pages/ProjectFileCollaborationPage.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { selectUser } from '../store/slices/authSlice';
import { API_BASE_URL } from '../config/api';
import FileCollaborationPage from './FileCollaborationPage';
import ProjectNavbar from '../components/ProjectNavbar';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API_BASE = API_BASE_URL;

const ProjectFileCollaborationPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const user = useSelector((state: RootState) => selectUser(state));
  const navigate = useNavigate();
  const [project, setProject] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProject = async () => {
      if (!projectId) return;
      
      try {
        const res = await axios.get(`${API_BASE}/projects/${projectId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        
        if (res.data.success) {
          setProject(res.data.data);
        }
      } catch (err) {
        console.error('Erreur chargement projet:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [projectId]);

  if (!projectId || !user) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-600">Chargement...</p>
      </div>
    );
  }

  const isCreator = project?.creator?._id === user._id;

  return (
    <div className="min-h-screen bg-gray-50">
      <ProjectNavbar
        project={project}
        projectId={projectId}
        isCreator={isCreator}
      />
      
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="mb-4">
          <button
            onClick={() => navigate(`/projects/${projectId}?tab=collaboration`)}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Back to collaboration</span>
          </button>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
          <FileCollaborationPage
            projectId={projectId}
            user={user}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectFileCollaborationPage;

